import { r as Ve, j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { useContext as Ce, useCallback as Ye, useRef as dt, useEffect as ft, cloneElement as pt, useMemo as mt, useState as vt } from "react";
import { a as ht, g as yt } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { r as bt, I as gt } from "./_react-dom_commonjs-external-Bs0rGxnp.mjs";
import { p as Ze } from "./index-BpaEWJM0.mjs";
import { B as ue, b as Ct, a as Ot, c as xt, d as _t, e as Et, f as St } from "./hooks-nrLF1Lxr.mjs";
import { f } from "./index-LyFokDcn.mjs";
import { m as Fe } from "./mobile-BpUO1OTk.mjs";
import { m as P } from "./tss-DN0acMKN.mjs";
import { l as Mt } from "./lodash-5ofSKtz3.mjs";
import { L as Ft } from "./loader-CJQkrVUR.mjs";
import { I as je } from "./icon-button-BxDvkq_l.mjs";
import { c as wt } from "./index-DkZ16bcJ.mjs";
import { M as Y, d as Z } from "./constants-CnFYFetN.mjs";
import { d as At } from "./index-DspsydPg.mjs";
import { w as Lt } from "./sizes-DktS74Qp.mjs";
import { B as Dt } from "./button-CUHBhgeQ.mjs";
import { T as Nt } from "./text-button-yPCa43NP.mjs";
import { T as Tt } from "./text-field-ZOMRKQAY.mjs";
import { L as Ge } from "./layout-box-DFBM-kSI.mjs";
import { C as Q } from "./enums-BtUzbEmn.mjs";
import { T as Qe } from "./typography-Bj_iezxf.mjs";
import { I as Je } from "./icon-CvGUqXUP.mjs";
import { F as Me } from "./flex-Cc3osQLf.mjs";
import { H as Rt } from "./headline-DF2GOgMa.mjs";
import { B as Pt } from "./body-text-BiQwh5-U.mjs";
import { I as kt } from "./icon-tile-BJ1ib0c2.mjs";
import { I as jt } from "./icon-v2-DGtVEk7e.mjs";
import { B as It } from "./badge-v2-GpmLELaL.mjs";
import { C as Bt } from "./content-iXOVBfdp.mjs";
var we = { exports: {} }, G = {}, Ae = { exports: {} }, k = {}, Le = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = g;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var n = "none", o = "contents", a = /input|select|textarea|button|object|iframe/;
  function i(h, b) {
    return b.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    h.scrollWidth <= 0 && h.scrollHeight <= 0;
  }
  function u(h) {
    var b = h.offsetWidth <= 0 && h.offsetHeight <= 0;
    if (b && !h.innerHTML) return !0;
    try {
      var C = window.getComputedStyle(h), O = C.getPropertyValue("display");
      return b ? O !== o && i(h, C) : O === n;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function s(h) {
    for (var b = h, C = h.getRootNode && h.getRootNode(); b && b !== document.body; ) {
      if (C && b === C && (b = C.host.parentNode), u(b)) return !1;
      b = b.parentNode;
    }
    return !0;
  }
  function p(h, b) {
    var C = h.nodeName.toLowerCase(), O = a.test(C) && !h.disabled || C === "a" && h.href || b;
    return O && s(h);
  }
  function y(h) {
    var b = h.getAttribute("tabindex");
    b === null && (b = void 0);
    var C = isNaN(b);
    return (C || b >= 0) && p(h, !C);
  }
  function g(h) {
    var b = [].slice.call(h.querySelectorAll("*"), 0).reduce(function(C, O) {
      return C.concat(O.shadowRoot ? g(O.shadowRoot) : [O]);
    }, []);
    return b.filter(y);
  }
  t.exports = e.default;
})(Le, Le.exports);
var Xe = Le.exports;
Object.defineProperty(k, "__esModule", {
  value: !0
});
k.resetState = Wt;
k.log = qt;
k.handleBlur = le;
k.handleFocus = ce;
k.markForFocusLater = zt;
k.returnFocus = Kt;
k.popWithoutFocus = Vt;
k.setupScopedFocus = Yt;
k.teardownScopedFocus = Zt;
var Ut = Xe, Ht = $t(Ut);
function $t(t) {
  return t && t.__esModule ? t : { default: t };
}
var X = [], J = null, De = !1;
function Wt() {
  X = [];
}
function qt() {
}
function le() {
  De = !0;
}
function ce() {
  if (De) {
    if (De = !1, !J)
      return;
    setTimeout(function() {
      if (!J.contains(document.activeElement)) {
        var t = (0, Ht.default)(J)[0] || J;
        t.focus();
      }
    }, 0);
  }
}
function zt() {
  X.push(document.activeElement);
}
function Kt() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, e = null;
  try {
    X.length !== 0 && (e = X.pop(), e.focus({ preventScroll: t }));
    return;
  } catch {
    console.warn(["You tried to return focus to", e, "but it is not in the DOM anymore"].join(" "));
  }
}
function Vt() {
  X.length > 0 && X.pop();
}
function Yt(t) {
  J = t, window.addEventListener ? (window.addEventListener("blur", le, !1), document.addEventListener("focus", ce, !0)) : (window.attachEvent("onBlur", le), document.attachEvent("onFocus", ce));
}
function Zt() {
  J = null, window.addEventListener ? (window.removeEventListener("blur", le), document.removeEventListener("focus", ce)) : (window.detachEvent("onBlur", le), document.detachEvent("onFocus", ce));
}
var Ne = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var n = Xe, o = a(n);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return s.activeElement.shadowRoot ? i(s.activeElement.shadowRoot) : s.activeElement;
  }
  function u(s, p) {
    var y = (0, o.default)(s);
    if (!y.length) {
      p.preventDefault();
      return;
    }
    var g = void 0, h = p.shiftKey, b = y[0], C = y[y.length - 1], O = i();
    if (s === O) {
      if (!h) return;
      g = C;
    }
    if (C === O && !h && (g = b), b === O && h && (g = C), g) {
      p.preventDefault(), g.focus();
      return;
    }
    var F = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), A = F != null && F[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (A) {
      var I = y.indexOf(O);
      if (I > -1 && (I += h ? -1 : 1), g = y[I], typeof g > "u") {
        p.preventDefault(), g = h ? C : b, g.focus();
        return;
      }
      p.preventDefault(), g.focus();
    }
  }
  t.exports = e.default;
})(Ne, Ne.exports);
var Gt = Ne.exports, j = {}, Qt = function() {
}, Jt = Qt, R = {}, et = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(t) {
  (function() {
    var e = !!(typeof window < "u" && window.document && window.document.createElement), n = {
      canUseDOM: e,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: e && !!(window.addEventListener || window.attachEvent),
      canUseViewport: e && !!window.screen
    };
    t.exports ? t.exports = n : window.ExecutionEnvironment = n;
  })();
})(et);
var Xt = et.exports;
Object.defineProperty(R, "__esModule", {
  value: !0
});
R.canUseDOM = R.SafeNodeList = R.SafeHTMLCollection = void 0;
var en = Xt, tn = nn(en);
function nn(t) {
  return t && t.__esModule ? t : { default: t };
}
var Oe = tn.default, on = Oe.canUseDOM ? window.HTMLElement : {};
R.SafeHTMLCollection = Oe.canUseDOM ? window.HTMLCollection : {};
R.SafeNodeList = Oe.canUseDOM ? window.NodeList : {};
R.canUseDOM = Oe.canUseDOM;
R.default = on;
Object.defineProperty(j, "__esModule", {
  value: !0
});
j.resetState = cn;
j.log = un;
j.assertNodeList = tt;
j.setElement = dn;
j.validateElement = Re;
j.hide = fn;
j.show = pn;
j.documentNotReadyOrSSRTesting = mn;
var rn = Jt, an = ln(rn), sn = R;
function ln(t) {
  return t && t.__esModule ? t : { default: t };
}
var L = null;
function cn() {
  L && (L.removeAttribute ? L.removeAttribute("aria-hidden") : L.length != null ? L.forEach(function(t) {
    return t.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(L).forEach(function(t) {
    return t.removeAttribute("aria-hidden");
  })), L = null;
}
function un() {
}
function tt(t, e) {
  if (!t || !t.length)
    throw new Error("react-modal: No elements were found for selector " + e + ".");
}
function dn(t) {
  var e = t;
  if (typeof e == "string" && sn.canUseDOM) {
    var n = document.querySelectorAll(e);
    tt(n, e), e = n;
  }
  return L = e || L, L;
}
function Re(t) {
  var e = t || L;
  return e ? Array.isArray(e) || e instanceof HTMLCollection || e instanceof NodeList ? e : [e] : ((0, an.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function fn(t) {
  var e = !0, n = !1, o = void 0;
  try {
    for (var a = Re(t)[Symbol.iterator](), i; !(e = (i = a.next()).done); e = !0) {
      var u = i.value;
      u.setAttribute("aria-hidden", "true");
    }
  } catch (s) {
    n = !0, o = s;
  } finally {
    try {
      !e && a.return && a.return();
    } finally {
      if (n)
        throw o;
    }
  }
}
function pn(t) {
  var e = !0, n = !1, o = void 0;
  try {
    for (var a = Re(t)[Symbol.iterator](), i; !(e = (i = a.next()).done); e = !0) {
      var u = i.value;
      u.removeAttribute("aria-hidden");
    }
  } catch (s) {
    n = !0, o = s;
  } finally {
    try {
      !e && a.return && a.return();
    } finally {
      if (n)
        throw o;
    }
  }
}
function mn() {
  L = null;
}
var ee = {};
Object.defineProperty(ee, "__esModule", {
  value: !0
});
ee.resetState = vn;
ee.log = hn;
var ae = {}, se = {};
function Ie(t, e) {
  t.classList.remove(e);
}
function vn() {
  var t = document.getElementsByTagName("html")[0];
  for (var e in ae)
    Ie(t, ae[e]);
  var n = document.body;
  for (var o in se)
    Ie(n, se[o]);
  ae = {}, se = {};
}
function hn() {
}
var yn = function(e, n) {
  return e[n] || (e[n] = 0), e[n] += 1, n;
}, bn = function(e, n) {
  return e[n] && (e[n] -= 1), n;
}, gn = function(e, n, o) {
  o.forEach(function(a) {
    yn(n, a), e.add(a);
  });
}, Cn = function(e, n, o) {
  o.forEach(function(a) {
    bn(n, a), n[a] === 0 && e.remove(a);
  });
};
ee.add = function(e, n) {
  return gn(e.classList, e.nodeName.toLowerCase() == "html" ? ae : se, n.split(" "));
};
ee.remove = function(e, n) {
  return Cn(e.classList, e.nodeName.toLowerCase() == "html" ? ae : se, n.split(" "));
};
var te = {};
Object.defineProperty(te, "__esModule", {
  value: !0
});
te.log = xn;
te.resetState = _n;
function On(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var nt = function t() {
  var e = this;
  On(this, t), this.register = function(n) {
    e.openInstances.indexOf(n) === -1 && (e.openInstances.push(n), e.emit("register"));
  }, this.deregister = function(n) {
    var o = e.openInstances.indexOf(n);
    o !== -1 && (e.openInstances.splice(o, 1), e.emit("deregister"));
  }, this.subscribe = function(n) {
    e.subscribers.push(n);
  }, this.emit = function(n) {
    e.subscribers.forEach(function(o) {
      return o(
        n,
        // shallow copy to avoid accidental mutation
        e.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, he = new nt();
function xn() {
  console.log("portalOpenInstances ----------"), console.log(he.openInstances.length), he.openInstances.forEach(function(t) {
    return console.log(t);
  }), console.log("end portalOpenInstances ----------");
}
function _n() {
  he = new nt();
}
te.default = he;
var Pe = {};
Object.defineProperty(Pe, "__esModule", {
  value: !0
});
Pe.resetState = Fn;
Pe.log = wn;
var En = te, Sn = Mn(En);
function Mn(t) {
  return t && t.__esModule ? t : { default: t };
}
var M = void 0, T = void 0, K = [];
function Fn() {
  for (var t = [M, T], e = 0; e < t.length; e++) {
    var n = t[e];
    n && n.parentNode && n.parentNode.removeChild(n);
  }
  M = T = null, K = [];
}
function wn() {
  console.log("bodyTrap ----------"), console.log(K.length);
  for (var t = [M, T], e = 0; e < t.length; e++) {
    var n = t[e], o = n || {};
    console.log(o.nodeName, o.className, o.id);
  }
  console.log("edn bodyTrap ----------");
}
function Be() {
  K.length !== 0 && K[K.length - 1].focusContent();
}
function An(t, e) {
  !M && !T && (M = document.createElement("div"), M.setAttribute("data-react-modal-body-trap", ""), M.style.position = "absolute", M.style.opacity = "0", M.setAttribute("tabindex", "0"), M.addEventListener("focus", Be), T = M.cloneNode(), T.addEventListener("focus", Be)), K = e, K.length > 0 ? (document.body.firstChild !== M && document.body.insertBefore(M, document.body.firstChild), document.body.lastChild !== T && document.body.appendChild(T)) : (M.parentElement && M.parentElement.removeChild(M), T.parentElement && T.parentElement.removeChild(T));
}
Sn.default.subscribe(An);
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(l) {
    for (var v = 1; v < arguments.length; v++) {
      var _ = arguments[v];
      for (var r in _)
        Object.prototype.hasOwnProperty.call(_, r) && (l[r] = _[r]);
    }
    return l;
  }, o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
    return typeof l;
  } : function(l) {
    return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
  }, a = /* @__PURE__ */ function() {
    function l(v, _) {
      for (var r = 0; r < _.length; r++) {
        var d = _[r];
        d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(v, d.key, d);
      }
    }
    return function(v, _, r) {
      return _ && l(v.prototype, _), r && l(v, r), v;
    };
  }(), i = Ve, u = Ze, s = U(u), p = k, y = D(p), g = Gt, h = U(g), b = j, C = D(b), O = ee, F = D(O), A = R, I = U(A), ne = te, x = U(ne);
  function D(l) {
    if (l && l.__esModule)
      return l;
    var v = {};
    if (l != null)
      for (var _ in l)
        Object.prototype.hasOwnProperty.call(l, _) && (v[_] = l[_]);
    return v.default = l, v;
  }
  function U(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function pe(l, v) {
    if (!(l instanceof v))
      throw new TypeError("Cannot call a class as a function");
  }
  function _e(l, v) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return v && (typeof v == "object" || typeof v == "function") ? v : l;
  }
  function Ee(l, v) {
    if (typeof v != "function" && v !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof v);
    l.prototype = Object.create(v && v.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), v && (Object.setPrototypeOf ? Object.setPrototypeOf(l, v) : l.__proto__ = v);
  }
  var oe = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, Se = function(v) {
    return v.code === "Tab" || v.keyCode === 9;
  }, N = function(v) {
    return v.code === "Escape" || v.keyCode === 27;
  }, H = 0, re = function(l) {
    Ee(v, l);
    function v(_) {
      pe(this, v);
      var r = _e(this, (v.__proto__ || Object.getPrototypeOf(v)).call(this, _));
      return r.setOverlayRef = function(d) {
        r.overlay = d, r.props.overlayRef && r.props.overlayRef(d);
      }, r.setContentRef = function(d) {
        r.content = d, r.props.contentRef && r.props.contentRef(d);
      }, r.afterClose = function() {
        var d = r.props, S = d.appElement, w = d.ariaHideApp, E = d.htmlOpenClassName, W = d.bodyOpenClassName, q = d.parentSelector, me = q && q().ownerDocument || document;
        W && F.remove(me.body, W), E && F.remove(me.getElementsByTagName("html")[0], E), w && H > 0 && (H -= 1, H === 0 && C.show(S)), r.props.shouldFocusAfterRender && (r.props.shouldReturnFocusAfterClose ? (y.returnFocus(r.props.preventScroll), y.teardownScopedFocus()) : y.popWithoutFocus()), r.props.onAfterClose && r.props.onAfterClose(), x.default.deregister(r);
      }, r.open = function() {
        r.beforeOpen(), r.state.afterOpen && r.state.beforeClose ? (clearTimeout(r.closeTimer), r.setState({ beforeClose: !1 })) : (r.props.shouldFocusAfterRender && (y.setupScopedFocus(r.node), y.markForFocusLater()), r.setState({ isOpen: !0 }, function() {
          r.openAnimationFrame = requestAnimationFrame(function() {
            r.setState({ afterOpen: !0 }), r.props.isOpen && r.props.onAfterOpen && r.props.onAfterOpen({
              overlayEl: r.overlay,
              contentEl: r.content
            });
          });
        }));
      }, r.close = function() {
        r.props.closeTimeoutMS > 0 ? r.closeWithTimeout() : r.closeWithoutTimeout();
      }, r.focusContent = function() {
        return r.content && !r.contentHasFocus() && r.content.focus({ preventScroll: !0 });
      }, r.closeWithTimeout = function() {
        var d = Date.now() + r.props.closeTimeoutMS;
        r.setState({ beforeClose: !0, closesAt: d }, function() {
          r.closeTimer = setTimeout(r.closeWithoutTimeout, r.state.closesAt - Date.now());
        });
      }, r.closeWithoutTimeout = function() {
        r.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, r.afterClose);
      }, r.handleKeyDown = function(d) {
        Se(d) && (0, h.default)(r.content, d), r.props.shouldCloseOnEsc && N(d) && (d.stopPropagation(), r.requestClose(d));
      }, r.handleOverlayOnClick = function(d) {
        r.shouldClose === null && (r.shouldClose = !0), r.shouldClose && r.props.shouldCloseOnOverlayClick && (r.ownerHandlesClose() ? r.requestClose(d) : r.focusContent()), r.shouldClose = null;
      }, r.handleContentOnMouseUp = function() {
        r.shouldClose = !1;
      }, r.handleOverlayOnMouseDown = function(d) {
        !r.props.shouldCloseOnOverlayClick && d.target == r.overlay && d.preventDefault();
      }, r.handleContentOnClick = function() {
        r.shouldClose = !1;
      }, r.handleContentOnMouseDown = function() {
        r.shouldClose = !1;
      }, r.requestClose = function(d) {
        return r.ownerHandlesClose() && r.props.onRequestClose(d);
      }, r.ownerHandlesClose = function() {
        return r.props.onRequestClose;
      }, r.shouldBeClosed = function() {
        return !r.state.isOpen && !r.state.beforeClose;
      }, r.contentHasFocus = function() {
        return document.activeElement === r.content || r.content.contains(document.activeElement);
      }, r.buildClassName = function(d, S) {
        var w = (typeof S > "u" ? "undefined" : o(S)) === "object" ? S : {
          base: oe[d],
          afterOpen: oe[d] + "--after-open",
          beforeClose: oe[d] + "--before-close"
        }, E = w.base;
        return r.state.afterOpen && (E = E + " " + w.afterOpen), r.state.beforeClose && (E = E + " " + w.beforeClose), typeof S == "string" && S ? E + " " + S : E;
      }, r.attributesFromObject = function(d, S) {
        return Object.keys(S).reduce(function(w, E) {
          return w[d + "-" + E] = S[E], w;
        }, {});
      }, r.state = {
        afterOpen: !1,
        beforeClose: !1
      }, r.shouldClose = null, r.moveFromContentToOverlay = null, r;
    }
    return a(v, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(r, d) {
        this.props.isOpen && !r.isOpen ? this.open() : !this.props.isOpen && r.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !d.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var r = this.props, d = r.appElement, S = r.ariaHideApp, w = r.htmlOpenClassName, E = r.bodyOpenClassName, W = r.parentSelector, q = W && W().ownerDocument || document;
        E && F.add(q.body, E), w && F.add(q.getElementsByTagName("html")[0], w), S && (H += 1, C.hide(d)), x.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var r = this.props, d = r.id, S = r.className, w = r.overlayClassName, E = r.defaultStyles, W = r.children, q = S ? {} : E.content, me = w ? {} : E.overlay;
        if (this.shouldBeClosed())
          return null;
        var lt = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", w),
          style: n({}, me, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, ct = n({
          id: d,
          ref: this.setContentRef,
          style: n({}, q, this.props.style.content),
          className: this.buildClassName("content", S),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", n({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), ut = this.props.contentElement(ct, W);
        return this.props.overlayElement(lt, ut);
      }
    }]), v;
  }(i.Component);
  re.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, re.propTypes = {
    isOpen: s.default.bool.isRequired,
    defaultStyles: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    style: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    className: s.default.oneOfType([s.default.string, s.default.object]),
    overlayClassName: s.default.oneOfType([s.default.string, s.default.object]),
    parentSelector: s.default.func,
    bodyOpenClassName: s.default.string,
    htmlOpenClassName: s.default.string,
    ariaHideApp: s.default.bool,
    appElement: s.default.oneOfType([s.default.instanceOf(I.default), s.default.instanceOf(A.SafeHTMLCollection), s.default.instanceOf(A.SafeNodeList), s.default.arrayOf(s.default.instanceOf(I.default))]),
    onAfterOpen: s.default.func,
    onAfterClose: s.default.func,
    onRequestClose: s.default.func,
    closeTimeoutMS: s.default.number,
    shouldFocusAfterRender: s.default.bool,
    shouldCloseOnOverlayClick: s.default.bool,
    shouldReturnFocusAfterClose: s.default.bool,
    preventScroll: s.default.bool,
    role: s.default.string,
    contentLabel: s.default.string,
    aria: s.default.object,
    data: s.default.object,
    children: s.default.node,
    shouldCloseOnEsc: s.default.bool,
    overlayRef: s.default.func,
    contentRef: s.default.func,
    id: s.default.string,
    overlayElement: s.default.func,
    contentElement: s.default.func,
    testId: s.default.string
  }, e.default = re, t.exports = e.default;
})(Ae, Ae.exports);
var Ln = Ae.exports;
function ot() {
  var t = this.constructor.getDerivedStateFromProps(this.props, this.state);
  t != null && this.setState(t);
}
function rt(t) {
  function e(n) {
    var o = this.constructor.getDerivedStateFromProps(t, n);
    return o ?? null;
  }
  this.setState(e.bind(this));
}
function at(t, e) {
  try {
    var n = this.props, o = this.state;
    this.props = t, this.state = e, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      o
    );
  } finally {
    this.props = n, this.state = o;
  }
}
ot.__suppressDeprecationWarning = !0;
rt.__suppressDeprecationWarning = !0;
at.__suppressDeprecationWarning = !0;
function Dn(t) {
  var e = t.prototype;
  if (!e || !e.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof t.getDerivedStateFromProps != "function" && typeof e.getSnapshotBeforeUpdate != "function")
    return t;
  var n = null, o = null, a = null;
  if (typeof e.componentWillMount == "function" ? n = "componentWillMount" : typeof e.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof e.componentWillReceiveProps == "function" ? o = "componentWillReceiveProps" : typeof e.UNSAFE_componentWillReceiveProps == "function" && (o = "UNSAFE_componentWillReceiveProps"), typeof e.componentWillUpdate == "function" ? a = "componentWillUpdate" : typeof e.UNSAFE_componentWillUpdate == "function" && (a = "UNSAFE_componentWillUpdate"), n !== null || o !== null || a !== null) {
    var i = t.displayName || t.name, u = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + i + " uses " + u + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (o !== null ? `
  ` + o : "") + (a !== null ? `
  ` + a : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof t.getDerivedStateFromProps == "function" && (e.componentWillMount = ot, e.componentWillReceiveProps = rt), typeof e.getSnapshotBeforeUpdate == "function") {
    if (typeof e.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    e.componentWillUpdate = at;
    var s = e.componentDidUpdate;
    e.componentDidUpdate = function(y, g, h) {
      var b = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : h;
      s.call(this, y, g, b);
    };
  }
  return t;
}
const Nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: Dn
}, Symbol.toStringTag, { value: "Module" })), Tn = /* @__PURE__ */ ht(Nn);
Object.defineProperty(G, "__esModule", {
  value: !0
});
G.bodyOpenClassName = G.portalClassName = void 0;
var Ue = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
  }
  return t;
}, Rn = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var o = 0; o < n.length; o++) {
      var a = n[o];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, n, o) {
    return n && t(e.prototype, n), o && t(e, o), e;
  };
}(), st = Ve, ye = de(st), Pn = bt, be = de(Pn), kn = Ze, m = de(kn), jn = Ln, He = de(jn), In = j, Bn = Hn(In), B = R, $e = de(B), Un = Tn;
function Hn(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e.default = t, e;
}
function de(t) {
  return t && t.__esModule ? t : { default: t };
}
function $n(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function We(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Wn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var qn = G.portalClassName = "ReactModalPortal", zn = G.bodyOpenClassName = "ReactModal__Body--open", z = B.canUseDOM && be.default.createPortal !== void 0, qe = function(e) {
  return document.createElement(e);
}, ze = function() {
  return z ? be.default.createPortal : be.default.unstable_renderSubtreeIntoContainer;
};
function ve(t) {
  return t();
}
var fe = function(t) {
  Wn(e, t);
  function e() {
    var n, o, a, i;
    $n(this, e);
    for (var u = arguments.length, s = Array(u), p = 0; p < u; p++)
      s[p] = arguments[p];
    return i = (o = (a = We(this, (n = e.__proto__ || Object.getPrototypeOf(e)).call.apply(n, [this].concat(s))), a), a.removePortal = function() {
      !z && be.default.unmountComponentAtNode(a.node);
      var y = ve(a.props.parentSelector);
      y && y.contains(a.node) ? y.removeChild(a.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, a.portalRef = function(y) {
      a.portal = y;
    }, a.renderPortal = function(y) {
      var g = ze(), h = g(a, ye.default.createElement(He.default, Ue({ defaultStyles: e.defaultStyles }, y)), a.node);
      a.portalRef(h);
    }, o), We(a, i);
  }
  return Rn(e, [{
    key: "componentDidMount",
    value: function() {
      if (B.canUseDOM) {
        z || (this.node = qe("div")), this.node.className = this.props.portalClassName;
        var o = ve(this.props.parentSelector);
        o.appendChild(this.node), !z && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(o) {
      var a = ve(o.parentSelector), i = ve(this.props.parentSelector);
      return { prevParent: a, nextParent: i };
    }
  }, {
    key: "componentDidUpdate",
    value: function(o, a, i) {
      if (B.canUseDOM) {
        var u = this.props, s = u.isOpen, p = u.portalClassName;
        o.portalClassName !== p && (this.node.className = p);
        var y = i.prevParent, g = i.nextParent;
        g !== y && (y.removeChild(this.node), g.appendChild(this.node)), !(!o.isOpen && !s) && !z && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!B.canUseDOM || !this.node || !this.portal)) {
        var o = this.portal.state, a = Date.now(), i = o.isOpen && this.props.closeTimeoutMS && (o.closesAt || a + this.props.closeTimeoutMS);
        i ? (o.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, i - a)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!B.canUseDOM || !z)
        return null;
      !this.node && z && (this.node = qe("div"));
      var o = ze();
      return o(ye.default.createElement(He.default, Ue({
        ref: this.portalRef,
        defaultStyles: e.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(o) {
      Bn.setElement(o);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), e;
}(st.Component);
fe.propTypes = {
  isOpen: m.default.bool.isRequired,
  style: m.default.shape({
    content: m.default.object,
    overlay: m.default.object
  }),
  portalClassName: m.default.string,
  bodyOpenClassName: m.default.string,
  htmlOpenClassName: m.default.string,
  className: m.default.oneOfType([m.default.string, m.default.shape({
    base: m.default.string.isRequired,
    afterOpen: m.default.string.isRequired,
    beforeClose: m.default.string.isRequired
  })]),
  overlayClassName: m.default.oneOfType([m.default.string, m.default.shape({
    base: m.default.string.isRequired,
    afterOpen: m.default.string.isRequired,
    beforeClose: m.default.string.isRequired
  })]),
  appElement: m.default.oneOfType([m.default.instanceOf($e.default), m.default.instanceOf(B.SafeHTMLCollection), m.default.instanceOf(B.SafeNodeList), m.default.arrayOf(m.default.instanceOf($e.default))]),
  onAfterOpen: m.default.func,
  onRequestClose: m.default.func,
  closeTimeoutMS: m.default.number,
  ariaHideApp: m.default.bool,
  shouldFocusAfterRender: m.default.bool,
  shouldCloseOnOverlayClick: m.default.bool,
  shouldReturnFocusAfterClose: m.default.bool,
  preventScroll: m.default.bool,
  parentSelector: m.default.func,
  aria: m.default.object,
  data: m.default.object,
  role: m.default.string,
  contentLabel: m.default.string,
  shouldCloseOnEsc: m.default.bool,
  overlayRef: m.default.func,
  contentRef: m.default.func,
  id: m.default.string,
  overlayElement: m.default.func,
  contentElement: m.default.func
};
fe.defaultProps = {
  isOpen: !1,
  portalClassName: qn,
  bodyOpenClassName: zn,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(e, n) {
    return ye.default.createElement(
      "div",
      e,
      n
    );
  },
  contentElement: function(e, n) {
    return ye.default.createElement(
      "div",
      e,
      n
    );
  }
};
fe.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, Un.polyfill)(fe);
G.default = fe;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = G, o = a(n);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  e.default = o.default, t.exports = e.default;
})(we, we.exports);
var Kn = we.exports;
const it = /* @__PURE__ */ yt(Kn), Vn = P()(({ palette: t }) => ({
  baseModalBody: {
    borderBottomLeftRadius: f.ifFeature("encore", "16px"),
    borderBottomRightRadius: f.ifFeature("encore", "16px"),
    display: "flex",
    flexDirection: "column",
    height: "100%",
    transition: "opacity 350ms ease, transform 350ms ease",
    width: "100%"
  },
  baseModalBodyHidden: {
    opacity: 0,
    transform: "translateY(-20px)"
  }
})), Yn = (t) => {
  const { children: e, className: n, ...o } = t, { isLoading: a } = Ce(ue), { classes: i, cx: u } = Vn();
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: u(i.baseModalBody, n, {
        [i.baseModalBodyHidden]: a
      }),
      ...o,
      children: e
    }
  );
}, Te = ({ biId: t }) => {
  const { isProcessing: e, close: n } = Ce(ue), o = /* @__PURE__ */ c.jsx(
    je,
    {
      "aria-label": window.jQuery ? $.__("close modal") : "close modal",
      "data-bi-id": t,
      icon: /* @__PURE__ */ c.jsx(gt, { "aria-hidden": "true" }),
      noBoundingBox: !0,
      onClick: n,
      type: "button"
    }
  ), a = /* @__PURE__ */ c.jsx(
    je,
    {
      "aria-label": window.jQuery ? $.__("close modal") : "close modal",
      "data-bi-id": t,
      icon: "xmark-solid",
      onClick: n,
      size: "small",
      type: "button",
      variant: "outlined"
    }
  );
  return e ? null : f.ifFeature("encore", a, o);
}, Zn = 250;
var ke = /* @__PURE__ */ ((t) => (t.PARTIALLY_OPAQUE = "partiallyOpaque", t.FULLY_OPAQUE = "fullyOpaque", t))(ke || {}), ge = /* @__PURE__ */ ((t) => (t.VERTICAL_FADE = "VERTICAL_FADE", t.ZOOM_FADE = "ZOOM_FADE", t))(ge || {});
const Yo = {
  VERTICAL_FADE: "verticalFade",
  ZOOM_FADE: "zoomFade"
};
function Gn(t, e, n) {
  const o = dt();
  ft(() => {
    const a = o.current, i = t.current;
    return i && a !== e && a && i.removeEventListener("keydown", a), i && (n ? i.addEventListener("keydown", e) : i.removeEventListener("keydown", e)), o.current = e, () => {
      i && i.removeEventListener("keydown", e);
    };
  }, [e, t, n]);
}
function Qn(t, e, n, o, a) {
  const i = Ye(
    (u) => {
      const s = t.indexOf(u.key), p = e[s], y = a[s];
      p && typeof p == "function" && !y && p(u);
    },
    [e, a, t]
  );
  Gn(o, i, n);
}
const Jn = P()((t, { minActionWidth: e, actionAlignment: n }) => {
  const { breakpoints: o } = t;
  return {
    baseModalFooter: {
      display: "flex",
      justifyContent: f.ifFeature("encore", n, void 0),
      /* @startCleanup encore */
      [o.down(500)]: f.ifFeature("encore", void 0, { display: "block" })
      /* @endCleanup encore */
    },
    baseModalFooterActions: {
      display: "flex"
    },
    baseModalFooterAction: {
      display: "inline-flex",
      margin: f.ifFeature("encore", n === "start" ? "0 16px 0 0" : "0 0 0 16px", "12px 16px 0 0"),
      width: Lt[e],
      [o.down(500)]: {
        width: "auto"
      }
    },
    minActionWidth: {}
  };
}), Xn = At.createLogger("@fabric/overlays/base-modal | <BaseModal.Footer />"), eo = (t) => {
  const { actionHotKeys: e = [], actions: n = [], actionAlignment: o = "end", minActionWidth: a = 100, children: i, className: u, ...s } = t, { classes: p, cx: y } = Jn({ minActionWidth: a, actionAlignment: o }), { contentRef: g, isOpen: h, isLoading: b, isProcessing: C } = Ce(ue), O = [Dt, Nt], F = n.filter((x) => x && O.includes(x.type));
  if (n.length !== F.length) {
    const x = O.map(({ name: D }) => D);
    Xn.error(
      `An unsupported component was supplied as an action to your modal's footer; it will be ignored. Valid components are: ${x.join(
        ", "
      )}.`
    );
  }
  const A = h && !b && !C, I = n.map((x) => x.props.clickAction ?? x.props.onClick), ne = n.map((x) => x.props.disabled ?? !1);
  return Qn(e, I, A, g, ne), /* @__PURE__ */ c.jsxs("div", { className: p.baseModalFooter, children: [
    /* @__PURE__ */ c.jsx("div", { className: p.baseModalFooterActions, children: F.map((x) => {
      var D;
      return /* @__PURE__ */ c.jsx("div", { className: y(p.baseModalFooterAction, u), ...s, children: pt(x, {
        isDisabled: x.props.isDisabled || C,
        isProcessing: C,
        /**
         * Force any "secondary" buttons to use "outline" styles.
         */
        outline: x.props.outline || x.props.secondary,
        size: f.ifFeature("encore", void 0, "large"),
        width: a
      }) }, (D = x.key) == null ? void 0 : D.toString());
    }) }),
    i
  ] });
}, to = P()(({ breakpoints: t, constructs: e, palette: n, mode: o, spacing: a }, { hasCloseButton: i, inverted: u }) => ({
  baseModalHeader: {
    alignItems: "center",
    backgroundColor: f.ifFeature("encore", u ? n.common.white : n.gray[50]),
    borderTopLeftRadius: f.ifFeature("encore", "12px"),
    borderTopRightRadius: f.ifFeature("encore", "12px"),
    display: "flex",
    outline: o === Y.Dye ? `1px solid ${Z.main}` : void 0,
    width: "100%",
    [t.down(Fe)]: f.ifFeature("encore", {
      backgroundColor: e.surface.neutral.xxWeak
    })
  },
  baseModalCloseButton: {
    padding: f.ifFeature("encore", a(2, 2.5)),
    [t.down("sm")]: f.ifFeature("encore", {
      padding: a(2)
    })
  },
  baseModalHeaderContent: {
    flex: f.ifFeature("encore", void 0, 1),
    flexGrow: f.ifFeature("encore", 1),
    padding: f.ifFeature("encore", i ? a(2, 0, 2, 2.5) : a(2, 2.5)),
    [t.down(Fe)]: f.ifFeature("encore", {
      padding: i ? a(2, 0, 2, 2.5) : a(2, 2.5)
    })
  }
})), no = (t) => {
  const { biId: e, children: n, className: o, hasCloseButton: a = !0, inverted: i, ...u } = t, { classes: s } = to({ hasCloseButton: a, inverted: i }), { ariaLabelledby: p } = Ce(ue), y = f.ifFeature(
    "encore",
    /* @__PURE__ */ c.jsx("div", { className: s.baseModalCloseButton, children: /* @__PURE__ */ c.jsx(Te, { biId: e }) }),
    /* @__PURE__ */ c.jsx(Te, { biId: e })
  );
  return /* @__PURE__ */ c.jsxs("div", { className: wt(s.baseModalHeader, o), ...u, children: [
    /* @__PURE__ */ c.jsx("div", { className: s.baseModalHeaderContent, id: p, children: n }),
    a ? y : null
  ] });
};
function oo({
  classes: t,
  cx: e,
  overlayTheme: n,
  parentSelector: o
}) {
  return {
    afterOpen: t.backDropAfterOpen,
    base: e(t.backDrop, {
      [t.backDropPartiallyOpaque]: n === ke.PARTIALLY_OPAQUE,
      [t.backDropInline]: !!o
    }),
    beforeClose: t.backDropBeforeClose
  };
}
function ro({
  classes: t,
  cx: e,
  transition: n
}) {
  return e({
    [t.verticalFade]: n === ge.VERTICAL_FADE,
    [t.zoomFade]: n === ge.ZOOM_FADE
  });
}
const ao = {
  "&:before": {
    content: '""',
    flex: 45
  },
  "&:after": {
    content: '""',
    flex: 55
  }
}, so = P()(({ breakpoints: t, mixins: e, palette: n, spacing: o }, a, i) => ({
  backDrop: {
    alignItems: "center",
    backgroundColor: f.ifFeature("encore", e.alpha(n.grey[700], 0.9), n.gray[100]),
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    left: 0,
    marginBottom: "auto",
    marginTop: "auto",
    opacity: 0,
    position: "fixed",
    right: 0,
    top: 0,
    ...f.ifFeature("encore", { justifyContent: "center" }, ao),
    "@media print": {
      background: "none"
      // Hides the backdrop when printing
    }
  },
  backDropAfterOpen: {
    [`&.${i.backDrop}`]: {
      opacity: "1"
    },
    [`&.${i.backDropPartiallyOpaque}`]: {
      backgroundColor: f.ifFeature(
        "encore",
        `rgba(${e.hexToRgb(n.gray[400])},0.95)`,
        `rgba(${e.hexToRgb(n.gray[200])},0.95)`
      )
    }
  },
  backDropBeforeClose: {
    [`&.${i.backDrop}`]: {
      opacity: 0,
      transitionDuration: "250ms"
    }
  },
  backDropInline: {
    position: "absolute"
  },
  backDropPartiallyOpaque: {
    backgroundColor: n.gray[200]
  },
  content: {
    boxSizing: f.ifFeature("encore", "border-box"),
    padding: f.ifFeature("encore", o(5)),
    position: "relative",
    width: "100%",
    [t.down(Fe)]: f.ifFeature("encore", {
      padding: o(1.5)
    }),
    "@media print": {
      padding: 0
    }
  },
  contentAfterOpen: {},
  contentBeforeClose: {},
  loader: {
    alignItems: "center",
    bottom: "0",
    display: "flex",
    justifycontent: "center",
    left: "0",
    position: "absolute",
    right: "0",
    top: "0"
  },
  verticalFade: {
    [`& .${i.backDrop}`]: {
      transition: "opacity 350ms ease"
    },
    [`& .${i.content}`]: {
      transform: "translateY(-20px)",
      transition: "transform 350ms ease"
    },
    [`&& .${i.contentAfterOpen}`]: {
      transform: "none"
    },
    [`&&& .${i.contentBeforeClose}`]: {
      transform: "translateY(20px)",
      transition: "transform 250ms ease"
    }
  },
  zoomFade: {
    [`.${i.backDrop}`]: {
      transition: "opacity 200ms linear"
    },
    [`.${i.content}`]: {
      transform: "scale(0)",
      transition: "transform 200ms ease 50ms"
    },
    [`.${i.contentAfterOpen}`]: {
      transform: "scale(1)"
    },
    [`.${i.contentBeforeClose}`]: {
      transform: "scale(0)",
      transitionDuration: "250ms"
    }
  }
})), { setAppElement: Zo } = it, xe = (t) => {
  const {
    ariaDescribedby: e,
    ariaLabelledby: n,
    children: o,
    className: a,
    // not used; prevents passing to ReactModal
    contentStyles: i = {},
    id: u,
    isLoading: s = !1,
    isOpen: p = !1,
    isProcessing: y = !1,
    onCloseComplete: g = () => {
    },
    onOpenComplete: h = () => {
    },
    onRequestClose: b = () => {
    },
    onlyPrintModal: C = !1,
    overlayStyles: O = {},
    overlayTheme: F = ke.FULLY_OPAQUE,
    parentSelector: A,
    shouldFocusAfterRender: I = !0,
    shouldReturnFocusAfterClose: ne = !0,
    transition: x = ge.VERTICAL_FADE,
    ...D
  } = t, U = mt(() => n || Mt.uniqueId("modal-header"), [n]), pe = Ct(), _e = Ot(p), Ee = xt(), [oe, Se] = vt(), { classes: N, cx: H } = so();
  _t(A ? "INLINE_MODAL" : "MODAL", p), Et(typeof A != "function", p, oe);
  const re = {
    zIndex: _e,
    ...O
  };
  return /* @__PURE__ */ c.jsx(
    ue.Provider,
    {
      value: {
        ...t,
        // if an ariaLabelledby id is provided, assume some unknown element will have that ID and do not use it internally
        ariaLabelledby: n ? void 0 : U,
        contentRef: pe,
        close: b
      },
      children: /* @__PURE__ */ c.jsxs(
        it,
        {
          aria: {
            describedby: e,
            labelledby: U
          },
          className: f.ifFeature(
            "encore",
            {
              base: N.content,
              afterOpen: N.contentAfterOpen,
              beforeClose: N.contentBeforeClose
            },
            a || {
              base: N.content,
              afterOpen: N.contentAfterOpen,
              beforeClose: N.contentBeforeClose
            }
          ),
          closeTimeoutMS: Zn,
          contentRef: (l) => {
            St(l), Ee(l), pe.current = l;
          },
          data: {
            "fabric-component": D["data-fabric-component"] || "BaseModal"
          },
          id: u,
          isOpen: p,
          onAfterClose: C ? () => {
            const l = document.getElementById("hideBackgroundForPrint");
            l && l.remove(), g();
          } : g,
          onAfterOpen: C ? () => {
            const l = document.createElement("style");
            l.id = "hideBackgroundForPrint", l.innerHTML = '@media print { body:has([role="dialog"]) > * { display: none; } body > div:has([role="dialog"]) { display: block; } }', document.head.appendChild(l), h();
          } : h,
          onRequestClose: b,
          overlayClassName: oo({ classes: N, cx: H, overlayTheme: F, parentSelector: A }),
          overlayRef: Ye((l) => Se(l), []),
          parentSelector: A,
          portalClassName: ro({ classes: N, cx: H, transition: x }),
          shouldCloseOnEsc: !y,
          shouldCloseOnOverlayClick: !1,
          shouldFocusAfterRender: I,
          shouldReturnFocusAfterClose: ne,
          style: {
            content: i,
            overlay: re
          },
          ...D,
          children: [
            p && s && /* @__PURE__ */ c.jsx("div", { className: N.loader, children: /* @__PURE__ */ c.jsx(Ft, {}) }),
            o
          ]
        }
      )
    }
  );
};
xe.Body = Yn;
xe.CloseButton = Te;
xe.Header = no;
xe.Footer = eo;
const io = P()((t) => {
  var i;
  const { palette: e, mode: n, typography: o, constructs: a } = t;
  return {
    container: {
      borderRadius: f.ifFeature("encore", "12px", void 0),
      color: n === Y.Dye ? Z.main : f.ifFeature("encore", a.text.error.strong, e.error.main),
      fontSize: (i = o.small) == null ? void 0 : i.fontSize,
      outline: n === Y.Dye ? `1px solid ${Z.main}` : void 0,
      textAlign: "center"
    }
  };
}), lo = P()((t) => {
  const { palette: e, mode: n } = t;
  return {
    root: {
      backgroundColor: f.ifFeature("encore", e.grey[50], e.grey[100]),
      padding: Q.MEDIUM,
      outline: n === Y.Dye ? `1px solid ${Z.main}` : void 0,
      borderRadius: 2
    }
  };
}), co = (t) => {
  const { children: e, ...n } = t, { classes: o } = lo();
  return /* @__PURE__ */ c.jsx("div", { className: o.root, ...n, children: e });
}, Go = (t) => {
  const { children: e, confirmationText: n, onConfirmationChange: o, ...a } = t, { classes: i } = io(), u = "confirmation-content-input";
  return /* @__PURE__ */ c.jsxs(co, { className: i.container, ...a, children: [
    e,
    /* @__PURE__ */ c.jsx(Ge, { marginBottom: 1, children: /* @__PURE__ */ c.jsx("label", { htmlFor: u, children: typeof n == "string" ? /* @__PURE__ */ c.jsx("p", { children: n }) : n }) }),
    /* @__PURE__ */ c.jsx(
      Tt,
      {
        id: u,
        inputProps: { autoComplete: "off" },
        onChange: (s) => o && o(s),
        width: 4
      }
    )
  ] });
}, Ke = {
  bottom: Q.SMALL,
  left: Q.SMALL,
  right: Q.SMALL,
  top: Q.SMALL
}, uo = P()((t, e) => {
  const { mode: n } = t, { canScroll: o } = e;
  return {
    root: {
      flexGrow: 1,
      overflow: o ? "auto" : "visible",
      outline: n === Y.Dye ? `1px solid ${Z.main}` : void 0
    },
    encoreContent: {
      padding: "32px 20px"
    }
  };
}), V = (t) => {
  const { canScroll: e = !0, children: n, spacingOverrides: o = Ke, className: a, ...i } = t, { classes: u, cx: s } = uo({ canScroll: e }), p = {
    ...Ke,
    ...o
  }, y = /* @__PURE__ */ c.jsx(Bt, { spacingOverrides: p, children: n }), g = /* @__PURE__ */ c.jsx("div", { className: u.encoreContent, children: n });
  return /* @__PURE__ */ c.jsx("div", { className: s(u.root, a), ...i, children: f.ifFeature("encore", g, y) });
};
V.Spacing = Q;
var ie = /* @__PURE__ */ ((t) => (t.LARGE = "large", t.MEDIUM = "medium", t.SMALL = "small", t))(ie || {});
const fo = P({ name: "HeroHeadline" })((t, e) => {
  const { constructs: n, palette: o, mixins: a, typography: i, spacing: u, mode: s } = t, { hasSeparator: p } = e;
  return {
    root: {
      textAlign: "center",
      ...p ? {
        borderBottom: a.border(1, f.ifFeature("encore", n.border.neutral.weak, o.gray[300])),
        paddingBottom: u(2.5)
      } : {}
    },
    // @startCleanup encore
    grimIcon: {
      fill: s === Y.Dye ? Z.main : o.primary.main
    },
    icon: {
      lineHeight: 0
    },
    typography: {
      color: o.gray[900],
      fontSize: i.medium.fontSize,
      lineHeight: i.medium.lineHeight,
      marginTop: u(0.5)
    }
    // @endCleanup encore
  };
}), po = {
  [ie.LARGE]: "h2",
  [ie.MEDIUM]: "h3",
  [ie.SMALL]: "h4"
}, Qo = ({
  className: t,
  children: e,
  hasSeparator: n,
  icon: o,
  iconColor: a = "primary-strong",
  size: i = ie.SMALL,
  subtext: u,
  text: s
}) => {
  const { classes: p, cx: y } = fo({ hasSeparator: n }), g = typeof o == "string" ? /* @__PURE__ */ c.jsx("div", { className: p.icon, children: /* @__PURE__ */ c.jsx(Je, { brand: !0, name: o }) }) : /* @__PURE__ */ c.jsx("div", { className: p.grimIcon, children: o }), h = o ? /* @__PURE__ */ c.jsx(Me, { justifyContent: "center", children: /* @__PURE__ */ c.jsx(kt, { icon: /* @__PURE__ */ c.jsx(jt, { color: a, name: o, size: 32 }), size: 64 }) }) : null, b = s && /* @__PURE__ */ c.jsx(Qe, { sx: o ? { mb: 0, mt: "20px" } : {}, variant: po[i], children: s }), C = s && /* @__PURE__ */ c.jsx(Me, { justifyContent: "center", children: /* @__PURE__ */ c.jsx(Ge, { paddingBottom: u ? 1 : void 0, paddingTop: "24px", children: /* @__PURE__ */ c.jsx(Rt, { color: "neutral-strong", size: "small", children: s }) }) }), O = u ? /* @__PURE__ */ c.jsx("p", { className: p.typography, children: u }) : null, F = u ? /* @__PURE__ */ c.jsx(Me, { justifyContent: "center", children: /* @__PURE__ */ c.jsx(Pt, { children: u }) }) : null;
  return /* @__PURE__ */ c.jsxs("div", { className: y(p.root, t), children: [
    f.ifFeature("encore", h, g),
    f.ifFeature("encore", C, b),
    f.ifFeature("encore", F, O),
    e
  ] });
}, mo = P()((t) => {
  const { palette: e, breakpoints: n, mixins: o } = t;
  return {
    root: {
      backgroundColor: f.ifFeature("encore", "transparent", e.gray[100]),
      borderTop: o.border(1, f.ifFeature("encore", e.gray[200], e.gray[400])),
      position: "relative",
      margin: f.ifFeature("encore", "0 20px"),
      padding: f.ifFeature("encore", "20px 0"),
      [n.down("md")]: {
        borderRadius: "0 0 2px, 2px"
      }
    }
  };
}), Jo = (t) => {
  const { children: e, ...n } = t, { classes: o } = mo(), a = /* @__PURE__ */ c.jsx(
    V,
    {
      spacingOverrides: {
        bottom: V.Spacing.SMALL,
        top: V.Spacing.SMALL
      },
      children: e
    }
  ), i = e;
  return /* @__PURE__ */ c.jsx("div", { className: o.root, ...n, children: f.ifFeature("encore", i, a) });
}, vo = P({ name: "StandardHeadline" })((t) => {
  const { palette: e, mixins: n, spacing: o, mode: a } = t;
  return {
    icon: {
      fill: a === Y.Dye ? Z.main : e.primary.main,
      lineHeight: 0,
      marginRight: 6
    },
    root: {
      alignItems: "center",
      borderBottom: n.border(1, e.gray[300]),
      display: "flex",
      paddingBottom: o(1)
    }
  };
}), Xo = (t) => {
  const { className: e, children: n, icon: o, text: a = "", description: i, ...u } = t, { classes: s, cx: p } = vo(t);
  return f.ifFeature(
    "encore",
    /* @__PURE__ */ c.jsxs(yo, { children: [
      /* @__PURE__ */ c.jsx(It, { icon: o || /* @__PURE__ */ c.jsx(c.Fragment, {}), size: "large", subtitle: i, title: a }),
      n
    ] }),
    /* @__PURE__ */ c.jsxs("div", { className: p(s.root, e), ...u, children: [
      o ? /* @__PURE__ */ c.jsx("span", { className: s.icon, children: typeof o == "string" ? /* @__PURE__ */ c.jsx(Je, { brand: !0, name: o }) : o }) : null,
      a ? /* @__PURE__ */ c.jsx(Qe, { component: "h3", sx: { m: 0 }, variant: "h4", children: a }) : null,
      n
    ] })
  );
}, ho = P()((t) => {
  const { palette: e, mixins: n } = t;
  return {
    root: {
      backgroundColor: f.ifFeature("encore", "transparent", e.gray[100]),
      borderBottom: n.border(1, f.ifFeature("encore", e.gray[200], e.gray[400])),
      borderRadius: "2px 2px 0 0",
      position: "relative",
      // for background attachments to .main (like confetti)
      margin: f.ifFeature("encore", "0 20px"),
      padding: f.ifFeature("encore", "20px 0"),
      alignItems: f.ifFeature("encore", "center"),
      display: f.ifFeature("encore", "flex")
    }
  };
}), yo = (t) => {
  const { children: e, ...n } = t, { classes: o } = ho(), a = /* @__PURE__ */ c.jsx(
    V,
    {
      spacingOverrides: {
        bottom: V.Spacing.SMALL,
        top: V.Spacing.SMALL
      },
      children: e
    }
  ), i = e;
  return /* @__PURE__ */ c.jsx("div", { className: o.root, ...n, children: f.ifFeature("encore", i, a) });
};
export {
  xe as B,
  Go as C,
  co as F,
  Qo as H,
  Jo as L,
  Zn as M,
  ke as O,
  Xo as S,
  ge as T,
  yo as U,
  V as a,
  Yo as b,
  ie as c,
  Zo as s
};
//# sourceMappingURL=upper-content-BgC1jI-u.mjs.map
